import {useRef} from 'react';

import {SimpleGrid} from '@mantine/core';
import {useNavigate} from 'react-router-dom';

import {useUsageEvents} from '../hooks/useUsageEvents.ts';
import {useTableColumns} from '../hooks/useTableColumns.tsx';

import {
    MantineDataTable,
    TableSearchForm,
    DataTableTokenPagination,
} from '@flexinet/ui-components';

export const RecordsTable = () => {
    const {columns} = useTableColumns();
    const navigate = useNavigate();

    const {
        items,
        totalCount,
        loading,
        nextToken,
        fetchRecords,
        handleFilterByKeyword
    } = useUsageEvents();

    const scrollViewportRef = useRef<HTMLDivElement>(null);

    // Read-only (FNP-536): no selection / no edit drawer. Row click opens the detail
    // view. The UsageEvent id is a COMPOSITE key (`usage-event:<uuid>`) containing `:`,
    // so it MUST be encodeURIComponent'd before going into the path — otherwise the
    // path could be mangled, useParams().id would come back partial, and
    // getUsageEvent(<partial id>) returns nothing → the detail page hangs on its loader
    // forever. react-router v6 useParams() auto-decodes, so the detail page receives the
    // original id. (Same composite-id rule as the sibling observability modules
    // FNP-533/534/535/585.)
    return (
        <SimpleGrid verticalSpacing='xl' m='sm'>
            <TableSearchForm handleFilterByKeyword={handleFilterByKeyword}/>

            <MantineDataTable
                columns={columns}
                records={items}
                fetching={loading}
                onScrollToBottom={() => fetchRecords()}
                scrollViewportRef={scrollViewportRef}
                withTableBorder={true}
                onRowClick={({record}) => navigate(`/usage-events/${encodeURIComponent(record.id)}`)}
            />

            <DataTableTokenPagination loadedCount={totalCount} nextToken={nextToken}
                                      handleLoadMore={fetchRecords}/>
        </SimpleGrid>
    );
};
